// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"0f0daea8","382":"cccf7895","523":"386c094a"}[chunkId] + ".chunk.css";
};